import { defineStore } from 'pinia';
import { ref } from 'vue';

import { LOCAL_AUTH_KEY } from '@/helpers/constants.ts';
import { xhr } from '@/helpers/service.ts';

export const useAuthenticationStore = defineStore('authentication', () => {
  const isAuthorised = ref(false);
  const authExpiry = ref(0);

  async function signIn(username: string, password: string) {
    const authenticationToken = await xhr('/user/login', {
      method: 'post',
      body: { username, password },
    });

    if (authenticationToken) {
      localStorage.setItem(LOCAL_AUTH_KEY, JSON.stringify(authenticationToken));
      checkAuthentication();
      return true;
    }

    return false;
  }

  function signOut() {
    isAuthorised.value = false;
    localStorage.removeItem(LOCAL_AUTH_KEY);
  }

  async function checkAuthentication() {
    const storage = localStorage.getItem(LOCAL_AUTH_KEY);
    const authentication = JSON.parse(storage || '{}');

    if (authentication.token && authentication.expires) {
      isAuthorised.value = true;
      authExpiry.value = authentication.expires;
      return true;
    }

    return false;
  }

  return {
    isAuthorised,
    authExpiry,
    signIn,
    signOut,
    checkAuthentication,
  };
});
